<template>
  <div class="pagination">
    <!-- 上一页按钮 -->
    <img :class="{ 'is-disabled': currentPage === 1 }" 
            @click="handlePageChange(currentPage - 1)"
            class="pagination-page"
            src="@assets/news/icon_page_left.png" 
            srcset="@assets/news/icon_page_left@2x.png 2x" />
    <!-- 首页 -->
    <div
      class="pagination-button"
      :class="{ 'is-active': currentPage === 0 }"
      @click="handlePageChange(0)"
    >
      1
    </div>

    <!-- 省略号 -->
    <span v-if="start > 2 && totalPages > 4" class="ellipsis">...</span>
    
    <!-- 中间页码 -->
    <div
      v-for="page in visiblePages"
      :key="page"
      class="pagination-button"
      :class="{ 'is-active': currentPage === page - 1 }"
      @click="handlePageChange(page - 1)"
    >
      {{ page }}
    </div>

    <!-- 省略号 -->
    <span v-if="end < totalPages - 1 && totalPages > 4" class="ellipsis">...</span>

    <!-- 尾页 -->
    <div
      v-if="totalPages > 1"
      class="pagination-button"
      :class="{ 'is-active': currentPage === totalPages - 1 }"
      @click="handlePageChange(totalPages - 1)"
    >
      {{ totalPages }}
    </div>

    <!-- 下一页按钮 -->
     <img :class="{ 'is-disabled': currentPage === totalPages - 1 }" 
            @click="handlePageChange(currentPage + 1)"
            class="pagination-page"
            src="@assets/news/icon_page_right.png"
            srcset="@assets/news/icon_page_right@2x.png 2x"  />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  emits: ['page-change'],
  computed: {
    totalPages() {
       return Math.ceil(this.total / this.pageSize);
    },
    start() {
       return Math.max(1, this.currentPage - 1);
    },
    end() {
       return Math.min(this.currentPage + 3, this.totalPages - 1);
    },
    visiblePages() {
      const start = Math.max(2, this.currentPage - 1);
      const end = Math.min(this.currentPage + 3, this.totalPages - 1);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  methods: {
    handlePageChange(page) {
      if (page >= 0 && page < this.totalPages) {
        this.$emit('page-change', page);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
}

.pagination-button {
    font-family: PingFangSC-medium;
    width: 40px;
    height: 40px;
    color: #0C3B81;
    font-weight: 500;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    margin: 0 2px;                          
}

 .pagination-button:hover {
    font-family: Roboto-regular;
    background-color: #0C3B81;
    color: #FFFFFF;                        
}

.pagination-button.is-active {
    font-family: Roboto-regular;
    background-color: #0C3B81;
    color: #FFFFFF;     
}

.pagination-button.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.pagination-page {
    padding: 20px;
    cursor: pointer;
}

.ellipsis {
    width: 40px;
    color: #0C3B81;
    text-align: center;
}

    /* 响应式布局 */
@media (max-width: 768px) {
    .pagination-button {
        width: 30px;
        height: 30px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        border-radius: 4px;
        margin: 0 2px;                          
    }

    .pagination-page {
        padding: 10px;
    }

    .ellipsis {
        width: 30px;
        color: #0C3B81;
        text-align: center;
    }
}
</style>
